<template>
  <div class="hello">
    <dir class="formBody">
      <form class="form-horizontal">
        <div v-for="(fieldMeta, index) in fieldSpec" class="form-control-wrapper" 
            v-bind:key="index">
          <FormControl 
            v-bind:control-type="modelAdapter.field2ControlType(fieldMeta)"
            v-bind:control-label="fieldMeta['verbose_name']"
            v-bind:is-required="fieldMeta['required']"
            v-bind:place-holder-text="'请输入' + fieldMeta['verbose_name']"
            v-model="fieldData[fieldMeta['field_name']]"
            v-bind:select-range="fieldData[modelAdapter.fieldOptionName(fieldMeta)]"
            custom-item="未选择"
            v-bind:readonly="readonly">
          </FormControl>   
        </div>
      </form>
      <div class="actionView">
        <div class="form-group">
          <label class='col-sm-2 control-label'>
              <span> </span>
          </label>
          <div class='col-sm-10'>
              <div v-if="readonly" class="btn btn-primary" v-on:click="goUpdate()">修改</div>
              <div v-else class="btn btn-primary" v-on:click="submitData()">保存</div>
          </div>
          <div class="clearfix"></div>
        </div>        
      </div>
    </dir>
  </div>
</template>

<script>
import FormControl from './FormControl.vue'
import crudService from '../../service/crud.js'
import uploadService from '../../service/upload.js'
import modelAdapterService from '../../service/modeladapter.js'

export default {
  name: 'ModelManagerPage',
  props: {
    lowerAppName: String,
    lowerModelName: String,
    version: String,
    objLabel: String,
    parentFieldName: {
      type: String,
      default: ''
    },
    parentId: {
      type: Number,
      default: 0
    }
  },
  components: {
    FormControl
  },
  data: function () {
    return {
      fieldSpec: [],
      fieldData: {},
      modelAdapter: null
    }
  },
  computed: {
    isDetailPage: function () {
      return this.$route.path.indexOf('detail') > 0
    },
    isCreatePage: function () {
      return this.$route.path.indexOf('create') > 0
    },
    isUpdatePage: function () {
      return this.$route.path.indexOf('update') > 0
    },
    readonly: function () {
      return this.$route.path.indexOf('detail') > 0
    },
    ID: function () {
      return this.$route.params.id
    },
    title: function () {
      if (this.isDetailPage) {
        return this.objLabel + '详情'
      } else if (this.isCreatePage) {
        return '创建' + this.objLabel
      } else if (this.isUpdatePage) {
        return '修改' + this.objLabel
      } else {
        return '标题异常'
      }
    }
  },
  methods: {
    collectURLs: function (uploadFields) {
      /**
       uploadFields: [
          {'fieldName': 'name1', fieldType': 'ImageField', 'fieldValue': 'data:url'},
          {'fieldName': 'name2', 'fieldType': 'AlbumField', 'fieldValue': [URL, URL...]}
       ]

       return [URL, URL...]

       relatedControl: ImageField, AlbumField, SlidesField
       */
      let urls = []
      uploadFields.forEach(function (uploadField) {
        if (uploadField['fieldType'] === 'ImageField') {
          urls.push(uploadField['fieldValue'])
        } else if (uploadField['fieldType'] === 'AlbumField') {
          urls = urls.concat(uploadField['fieldValue'])
        } else if (uploadField['fieldType'] === 'SlidesField') {
          uploadField['fieldValue'].forEach(function (slideItem) {
            urls.push(slideItem.image)
          })
        }
      })
      return urls
    },
    dispatchURLs: function (uploadFields, urls) {
      let index = 0
      uploadFields.forEach(function (uploadField) {
        if (uploadField['fieldType'] === 'ImageField') {
          uploadField['fieldValue'] = urls[index]
          index += 1
        } else if (uploadField['fieldType'] === 'AlbumField') {
          let albumLength = uploadField['fieldValue'].length
          uploadField['fieldValue'] = urls.slice(index, index + albumLength)
          index += albumLength
        } else if (uploadField['fieldType'] === 'SlidesField') {
          let slidesLength = uploadField['fieldValue'].length
          let slideURLs = urls.slice(index, index + slidesLength)
          for (var i = 0; i < slidesLength; i++) {
            uploadField['fieldValue'][i]['image'] = slideURLs[i]
          }
          index += slidesLength
        }
      })
    },
    submitData: function () {
      let that = this
      let params = {
      }
      let fieldInfos = []
      that.fieldSpec.forEach(function (fieldMeta) {
        let fieldType = fieldMeta['field_type']
        let fieldName = fieldMeta['field_name']
        let fieldValue = that.fieldData[fieldName]
        let fieldInfo = {'fieldName': fieldName,
          'fieldType': fieldType,
          'fieldValue': fieldValue,
          'isJsonField': fieldMeta['is_json_field']}
        fieldInfos.push(fieldInfo)
      })

      if (this.isUpdatePage) {
        params[this.lowerModelName + '_id'] = this.ID
      }

      let uploadContents = this.collectURLs(fieldInfos)
      uploadService.batchUpload(uploadContents, 'manager_upload', function (urls) {
        that.dispatchURLs(fieldInfos, urls)
        fieldInfos.forEach(function (fieldInfo) {
          let fieldType = fieldInfo['fieldType']
          let fieldName = fieldInfo['fieldName']
          let fieldValue = fieldInfo['fieldValue']
          if (fieldType !== 'ForeignKey' && fieldType !== 'DateField' && fieldType !== 'DateTimeField') {
            if (fieldInfo['isJsonField']) {
              params[fieldName] = JSON.stringify(fieldValue)
            } else {
              params[fieldName] = fieldValue
            }
          } else if (fieldType === 'ForeignKey') {
            fieldValue = parseInt(fieldValue)
            if (fieldValue) {
              params[fieldName] = fieldValue
            }
          } else if (fieldType === 'DateField') {
            if (fieldValue) {
              params[fieldName] = fieldValue
            }
          } else if (fieldType === 'DateTimeField') {
            if (fieldValue) {
              params[fieldName] = fieldValue
            }
          }
        })
        that.service.updateModel(params, function () {
          if (that.isCreatePage) {
            alert('创建成功')
          } else {
            alert('修改成功')
          }
          that.$router.go(-1)
        })
      }, function () {
        alert('图片上传失败')
      })
    },
    loadFieldSpec: function (callback) {
      let that = this
      this.service.loadModelFieldSpec(function (data) {
        that.fieldSpec = data.field_spec
        that.fieldSpec.forEach(function (fieldMeta) {
          if (that.modelAdapter.field2ControlType(fieldMeta) === 'select') {
            that.fieldData[that.modelAdapter.fieldOptionName(fieldMeta)] = []
          }
          that.$set(that.fieldData, fieldMeta['field_name'], fieldMeta['default_value'])
          that.fieldData[fieldMeta['field_name']] = fieldMeta['default_value']
        })
        callback()
      })
    },
    loadOptions: function (callback) {
      let that = this
      this.service.loadModelOptions(function (data) {
        Object.keys(data).forEach(function (key) {
          that.fieldData[key] = data[key]
        })
        that.$forceUpdate()
        callback()
      })
    },
    loadData: function () {
      let that = this
      let params = {}
      params[this.lowerModelName + '_id'] = this.ID
      this.service.getModelDetail(params, function (data) {
        Object.keys(data).forEach(function (key) {
          that.fieldData[key] = data[key]
        })
        that.$forceUpdate()
        // 字段的特殊处理
        // that.admin_division = [data.province, data.city, data.region]
      })
    },
    goUpdate: function () {
      this.$router.push('/' + this.lowerModelName + '/update/' + this.ID)
    }
  },
  created: function () {
    let that = this
    this.service = new crudService.ModelService(this.lowerAppName,
            this.lowerModelName, this.version)
    this.loadFieldSpec(function () {
      that.loadOptions(function () {
        if (that.isDetailPage || that.isUpdatePage) {
          that.loadData()
        }
        if (that.isCreatePage) {
          if (that.parentFieldName) {
            that.fieldData[that.parentFieldName] = that.parentId
          }
        }
      })
    })
    this.modelAdapter = new modelAdapterService.ModelAdapter()
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
form {
  padding-left: 20px;
  padding-right: 20px;
}
.formBody {
  margin-top: 30px;
  margin-bottom: 0; 
}
.form-control-wrapper {
  width: 100%;
}
.actionView {
  padding: 40px 3px 40px 3px;
}
</style>



// WEBPACK FOOTER //
// ModelManagerPage.vue?2df667cd